/**
 * Вызывает функцию не раньше чем через timeout мс после ее последнего вызова
 */
export const debounce = <F extends (...args: any[]) => any>({ timeout, func }: { timeout: number; func: F }) => {
  let timeoutId: null | NodeJS.Timeout = null;

  return (...args: Parameters<F>): NodeJS.Timeout => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      func(...args);
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }, timeout);

    return timeoutId;
  };
};
